import routes from './src/apps/pos/routes';
export default routes;
